module.exports = __webpack_public_path__ + "img/bjxsky1.2f224b67.jpg";